// extracted by mini-css-extract-plugin
export default {"imageIcon":"BulletCheckmark_imageIcon__yhzsg","textBullet":"BulletCheckmark_textBullet__PKgye","containerContent":"BulletCheckmark_containerContent__2DoFf"};